module.exports = __webpack_public_path__ + "static/media/horizontalExpandable.233a1e3d.svg";